<template>
  <div class="pic-ac">
    <el-input @keyup.enter.native="enterFire" class="ac-input" placeholder="请输入验证码" v-model="authCode" @input="authInput"></el-input>
    <img class="ac-img" @click="getValidateCode" :src="'data:image/png;base64,'+img" />
  </div>
</template>

<script>
import API from '@/api/api'
export default {
  name: 'pic-auth-code',
  props: ['value'],
  data () {
    return {
      authCode: this.value,
      img: ''
    }
  },
  computed: {

  },
  methods: {
    enterFire (e) {
      this.$emit('enterFire', e)
    },
    authInput (e) {
      this.$emit('input', e)
    },
    async getValidateCode () {
      //alert("getvalid... await")
      try {
        const res = await  API.getValidateCode()
        if (res.data.statusCode === '200') {
          this.img = res.data.result
        } else {
          throw new Error(res.data.message)
        }
      } catch (error) {
        this.$message({
          message: error,
          type: 'warning'
        })
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus">
.pic-ac
  width 100%
  display flex
  flex-direction row
  .ac-input
    width 60%
  .ac-img
    width 40%
    border 1px solid #d9d9d9
    max-height 40px
    border-radius 4px

</style>
